import Vivus from '../plugins/vivusPlugin';

// content initVivus
export default function initVivus()
{
    jQuery('.animate-svg svg').each(function()
    {
        new Vivus(this,
        {
            type:           'sync',
            duration:       80,
            forceRender:    true,
            onReady: function( obj )
            {
                obj.parentEl.style.opacity = '1';
            }
        });
    });
    
    jQuery.fn.vivusSvg = function() {
        let el = this.get(0);
        new Vivus(el,
        {
            type:           el.dataset.type,
            data:           el.data,
            duration:       80,
            delay:          el.dataset.delay,
            revers:         el.dataset.revers,
            forceRender:    true,
            onReady: function( obj )
            {
              obj.parentEl.style.opacity = '1';
            }
        });
    };

    jQuery('.vivus-svg').each(function()
    {
        $(this).vivusSvg();
    });

    jQuery('.svg-main').each(function()
    {
        new Vivus(this,
        {
            type: this.dataset.type,
            data: this.data,
            duration: 80,
            delay: this.dataset.delay,
            revers: this.dataset.revers,
            forceRender: true,
            onReady: function( obj )
            {
                obj.el.style.fillOpacity = '0',
                obj.el.style.fill        = '0',
                obj.el.style.transform   = 'translateY(-150px)';
                obj.el.style.transition  = 'all .9s ease';
                obj.el.style.overflow    = 'hidden';
      
                function animate()
                {
                    obj.el.style.fillOpacity    = '1',
                    obj.el.style.transform      = 'translateY(0)';
                    obj.parentEl.style.opacity  = '1';
                    obj.el.style.fill           = '100%';
                    obj.el.style.overflow       = 'hidden';
                }
        
                if ( obj.getStatus() !=='end' )
                {
                    setTimeout( () => { animate(obj) }, 75 );
                }
            }
        });
    });
}